module.exports = __webpack_public_path__ + "img/tab_Guide_S.5a916e71.png";